// EditButtonRenderer.jsx
import React, { useState } from "react";
import {
  EditFilled,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";

const AgTableEditButton = (props) => {
  const [editMode, setEditMode] = useState(false);

  const handleCloseEditing = () => {
    setEditMode(false);
    // props.colDef.editFunction(props, false);
    props.api.stopEditing(true);

    // props.api.refreshCells({ force: true });
  };

  const handleSaveEditing = () => {
    setEditMode(false);
    props.colDef.editFunction(props, false);

    // props.api.refreshCells({ force: true });
  };

  return editMode ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <CheckCircleFilled
        style={{
          fontSize: 20,
          cursor: "pointer",
          marginRight: 12,
          color: "#43a522",
        }}
        onClick={handleSaveEditing}
      />
      <CloseCircleFilled
        style={{ fontSize: 18, cursor: "pointer", color: "#dd5061" }}
        onClick={handleCloseEditing}
      />
    </div>
  ) : (
    <EditFilled
      style={{
        fontSize: 18,
        cursor: "pointer",
      }}
      onClick={() => {
        setEditMode(true);
        props.colDef.editFunction(props, true, props?.colDef?.focusKey);
      }}
    />
  );
};

export default AgTableEditButton;
